import { IconWrapper } from '../runtime';
export default IconWrapper('workbench', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M12.25 14.25L3.75 14.25M12.75 11.25L3.25 11.25C2.42157 11.25 1.75 10.5784 1.75 9.75L1.75 3.25C1.75 2.42157 2.42157 1.75 3.25 1.75L12.75 1.75C13.5784 1.75 14.25 2.42157 14.25 3.25L14.25 9.75C14.25 10.5784 13.5784 11.25 12.75 11.25Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M5 7.40039L7 5.40039L9 7.40039L11 5.40039",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});